import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { Place, ConsolidatedMetrics } from '@/types';

interface UseOverTimeDataResult {
  data: ConsolidatedMetrics[] | null;
  loading: boolean;
  error: string | null;
}

export const useOverTimeData = (selectedPlace: Place | null): UseOverTimeDataResult => {
  const [data, setData] = useState<ConsolidatedMetrics[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOverTimeData = async () => {
      console.log('🟨 useOverTimeData - starting fetch for:', selectedPlace);
      
      if (!selectedPlace) {
        console.log('🟨 useOverTimeData - no selectedPlace, clearing data');
        setData(null);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        console.log('🟨 useOverTimeData - querying database for:', {
          Place: selectedPlace.name,
          place_fips: selectedPlace.place_fips
        });
        
        const { data, error } = await supabase
          .from('consolidated_jurisdiction_metrics')
          .select('*')
          .eq('Place', selectedPlace.name)
          .eq('place_fips', selectedPlace.place_fips)
          .order('year', { ascending: false })
          .limit(6);

        if (error) {
          console.error('🟨 useOverTimeData - database error:', error);
          throw error;
        }

        console.log('🟨 useOverTimeData - received data:', data);
        setData(data as ConsolidatedMetrics[]);
      } catch (err) {
        console.error('🟨 useOverTimeData - fetch error:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch over time data');
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchOverTimeData();
  }, [selectedPlace]);

  return { data, loading, error };
}; 